exports.default = {
  'new_conversation_tooltip': '新建对话',
  'history_tooltip': '历史记录',
  'conversation': '对话',
  'loading': '加载中',
  'expand': '展开',
  'collapse': '收起',
  'start_new_conversation': '开启新的对话',
  'history': '历史',
  'pin_conversation': '置顶对话',
  'edit_conversation_title': '编辑对话名称',
  'remove_conversation_confirm': '删除确认',
  'please_enter_conversation_name': '请输入修改的对话名称',
  'delete_conversation_confirm': '删除后将无法恢复，确认要删除吗？',
  'delete': '删除',
  'cancel': '取消',
  'operation_failed': '操作失败：{message}',
  'empty_conversation_id': '对话ID为空，请刷新页面再试！',
  'empty_title': '请输入会话标题！',
  'title_too_long': '标题不能超过150个字符',
  'copy_success': '复制成功',
  'copy_failed': '复制失败，请稍后重试！',
  'no_agent_conversation': '您还未与任何智能体进行会话',
  'agent_deleted': '智能体已删除，无法发起新对话',
  'no_more': '没有更多了',
  'continue_chat': '和 Pai 接着聊',
  'ai_generated_content': '内容由 AI 大模型生成，请仔细甄别',
  'new_conversation': '新建会话',
  'add_conversation_title': '请输入会话标题',
  'confirm': '确 定',
  'your_agents': '您的智能体',
  'edit_conversation_failed': '操作失败：{message}',
  'add_top_success': '添加成功！',
  'export_pdf': '导出 PDF 文档',
  'agent_center': '智能体中心',
  'remove_agent': '移除智能体',
  'add_agent': '添加智能体',
  'today': '今天',
  'search_agent_placeholder': '搜索智能体名称或介绍',
  'recent': '最近',
  'points': '积分',
  'points_consumption': '每条信息消耗积分:',
  'remaining_points': '您当前剩余积分:',
  'points_info_load_error': '积分信息加载失败',
  'upgrade': '升级',
  'search_chat': '搜索智能体或对话...',
  'agent_type': '智能体',
  'conversation_message_type': '对话消息',
  'network_connection_unstable': '当前网络状况不佳，请刷新页面后重试。'
}
